export const maintenanceConfig = {
  isActive: false,
  testUsers: [4967, 4968, 4969, 4970],
  title: "Scheduled Maintenance",
  description:
    "Our website is currently under maintenance. We’ll be back shortly. Thank you for your patience!",
};
